/**
 * Show an article the way it was submitted.
 * HTML from the editor is sanitized and otherwise left unchanged.
 * Plain text keeps its line breaks, with repeated blank lines collapsed to one.
 */

import { plainLinesFromText } from './articleFormatting';
import { sanitizeArticleHtml } from './sanitizeArticleHtml';

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function hasHtml(value) {
  return /<[a-z!/]/i.test(value);
}

export function formatArticleContent(content) {
  if (!content) return '';
  const raw = String(content);
  if (hasHtml(raw)) return sanitizeArticleHtml(raw);
  const lines = plainLinesFromText(raw);
  if (!lines.length) return '';
  return lines.map((line) => (line ? escapeHtml(line) : '')).join('<br>');
}

export function editorArticleHtml(content) {
  if (!content) return '';
  const raw = String(content);
  if (hasHtml(raw)) return sanitizeArticleHtml(raw);
  return plainLinesFromText(raw)
    .map((line) => `<p>${line ? escapeHtml(line) : '<br>'}</p>`)
    .join('');
}
